import Outputs from './Outputs'

export default Outputs
